/* eslint-disable camelcase */
import SidebarCart from "./SidebarCart";
import AjaxBlocking from "./AjaxBlocking";

export default class AddToCart {
    constructor() {
        this.isCartPage = document.querySelector("div.cart-page");
        this.isCartPage = !!this.isCartPage;
        this.sidebarCart = new SidebarCart();
    }

    init() {
        this.events();
    }

    events() {
        const closeAddToCartModal = document.querySelector(
            ".jsAddToCartModalClose"
        );

        if (closeAddToCartModal) {
            const modalContainer = document.querySelector(".jsAddToCartModal");
            closeAddToCartModal.addEventListener("click", (e) => {
                modalContainer.classList.add("is-hidden");
            });
        }

        document.querySelectorAll("body")[0].addEventListener("click", (e) => {
            if (e.target.classList.contains("js-add-to-cart")) {
                e.preventDefault();
                this.add_to_cart(e.target);
            } else if (e.target.closest(".js-add-to-cart")) {
                e.preventDefault();
                this.add_to_cart(e.target.closest(".js-add-to-cart"));
            }
        });
    }

    remove_events() {
        [...this.add_to_cart_button].forEach((el) => {
            el.removeEventListener("click", null);
        });
    }

    add_to_cart(element) {
        let qty = 1;
        const parent_el = Array.from(element.parentNode.children).filter(
            (child) => (child) => child.classList.contains("quantity")
        );

        const widthWindow =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;

        if (parent_el[0].classList.contains("quantity")) {
            qty = parent_el[0].querySelector(".qty").value;
        }

        if (isNaN(qty) || qty === "") {
            qty = 1;
        }

        const id = element.dataset.productId;

        this.blockForAjax(element);

        fetch(window.global.ajax_url + "?action=addProductToCart", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: new URLSearchParams({
                security: window.global.security,
                id: id,
                qty: qty,
                isCartPage: this.isCartPage,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success === false) {
                    const noticeContainer = document.querySelector(
                        ".jsPageNoticeWrapper"
                    );
                    const noticesWrapper = document.getElementById(
                        "page__notices-wrapper"
                    );

                    noticesWrapper.innerHTML = data.data.wc_notices;

                    if (noticeContainer) {
                        noticeContainer.classList.remove("is-hidden");

                        window.setTimeout(() => {
                            noticeContainer.classList.add("is-hidden");
                        }, 10000);
                    }
                }

                if (data.success) {
                    if (data.data.cart_count) {
                        [
                            ...document.getElementsByClassName(
                                "header-top__cart--count"
                            ),
                        ].forEach((el) => {
                            el.innerHTML = data.data.cart_count;
                        });
                    }

                    if (fbq && typeof fbq === "function") {
                        if (isNaN(data.data.item_price)) {
                            console.log(
                                data.data.item_price + " is not a number"
                            );
                        } else {
                            console.log(data.data.item_price + " is a number");
                            if (
                                data.data.item_price &&
                                data.data.item_currency
                            ) {
                                fbq("track", "AddToCart", {
                                    content_name: data.data.item_name,
                                    content_ids:
                                        "['" + data.data.item_id + "']",
                                    content_type: "product",
                                    value: data.data.item_price,
                                    currency: data.data.item_currency,
                                });
                            }
                        }
                    }

                    if (widthWindow < 1280) {
                        const modalContainer =
                            document.querySelector(".jsAddToCartModal");

                        if (modalContainer) {
                            this.modalAfterAddToCart(
                                modalContainer,
                                data.data.item_image,
                                data.data.item_name,
                                data.data.cart_count,
                                data.data.cart_total
                            );
                        }
                    } else {
                        const noticeContainer = document.querySelector(
                            ".jsPageNoticeWrapper"
                        );
                        const noticesWrapper = document.getElementById(
                            "page__notices-wrapper"
                        );

                        noticesWrapper.innerHTML = data.data.wc_notices;

                        if (noticeContainer) {
                            noticeContainer.classList.remove("is-hidden");

                            window.setTimeout(() => {
                                noticeContainer.classList.add("is-hidden");
                            }, 10000);
                        }
                    }
                }

                if (this.isCartPage) {
                    location.reload();
                }

                if (element.closest(".cart-sidebar__content")) {
                    this.sidebarCart.getCartContent();
                }
                this.unblockForAjax(element);
            })
            .catch((err) => {
                console.log(err);
                this.unblockForAjax(element);
            });
    }

    modalAfterAddToCart(modalContainer, image, name, count, total) {
        const modalContainerImage = document.querySelector(
            ".jsAddToCartModalImage"
        );
        const modalContainerName = document.querySelector(
            ".jsAddToCartModalName"
        );
        const modalContainerCount = document.querySelector(
            ".jsAddToCartModalCount"
        );
        const modalContainerTotal = document.querySelector(
            ".jsAddToCartModalTotal"
        );

        modalContainerImage.innerHTML = image;
        modalContainerName.innerHTML = name;
        modalContainerCount.innerHTML = count;
        modalContainerTotal.innerHTML = total;

        modalContainer.classList.remove("is-hidden");
    }

    blockForAjax(element) {
        if (!element) return;

        const myBlock = new AjaxBlocking();
        myBlock.blockOnAjax(element);
    }

    unblockForAjax(element) {
        if (!element) return;

        const myBlock = new AjaxBlocking();
        myBlock.unblockOnAjax(element);
    }
}
